"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ColumnPropTypes = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  key: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  minWidth: _propTypes["default"].number,
  formatter: _propTypes["default"].any,
  cellClass: _propTypes["default"].string,
  sortable: _propTypes["default"].bool,
  headerBackgroundColor: _propTypes["default"].string
}));
var _default = ColumnPropTypes;
exports["default"] = _default;